import { useBrokerStore } from '@/features/Broker/store';
import { HttpAxiosClient } from '@/services/api/clients/HttpAxiosClient';
import type { IHttpClient } from '@/services/api/HttpClient';
import { HttpServiceProvider } from '@/services/api/HttpServiceProvider';
import { LOGGER_MODULE } from '@/services/logger/types';
import { useLogger } from '@/services/logger/useLogger';

let httpClientInstance: IHttpClient;
let httpServiceProvider: HttpServiceProvider;

const createDefaultHttpAxiosClient = () => {
  return new HttpAxiosClient(
    useLogger(LOGGER_MODULE.AXIOS),
    useBrokerStore().bedarfInformation.bedarfId,
    undefined,
  );
};
export const useApi = (
  newHttpClient?: IHttpClient,
  forceNewInitialisation = false,
): HttpServiceProvider => {
  if (httpClientInstance === undefined || forceNewInitialisation) {
    httpClientInstance = newHttpClient || createDefaultHttpAxiosClient();
  }

  if (httpServiceProvider === undefined || forceNewInitialisation) {
    httpServiceProvider = new HttpServiceProvider(httpClientInstance);
  }

  return httpServiceProvider;
};

export const getApiHttpClientInstance = () => {
  if (httpClientInstance === undefined) {
    httpClientInstance = createDefaultHttpAxiosClient();
  }

  return httpClientInstance;
};
